import { render, staticRenderFns } from "./medic.vue?vue&type=template&id=10f723f5&scoped=true"
import script from "./medic.vue?vue&type=script&lang=js"
export * from "./medic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f723f5",
  null
  
)

export default component.exports